import { observer, inject } from "mobx-react";
import { Input, Select, Status } from "../UI";
import styled from "styled-components";
import DeleteImg from "../asserts/img/delete_doc.svg";
import EditImg from "../asserts/img/edit_doc.svg";
import CancelImg from "../asserts/img/cancel.svg";
import UpdateImg from "../asserts/img/done.svg";
import { useTranslation } from "react-i18next";
import { openInNewTab } from "../utils/helper";
import { useEffect, useState } from "react";
import { renderKeyValue } from "../components/Common";

const StyledBox = styled.div(({ theme, backgroungColor }) => ({
  borderRadius: 7,
  borderBottom: "1px solid #EAE9F1",
  borderRadius: 0,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  flexWrap: "wrap",
  background: backgroungColor ? backgroungColor : theme.color.white,
  boxShadow: `0px 4px 30px rgba(74, 105, 166, 0.13)`,
  cursor: "pointer",
  height: 48,

  "&[alt='edit row']": {},
}));

const BoxContent = styled.div(({ width }) => ({
  width: width,
  paddingInlineStart: 10,
  paddingInlineEnd: 10,
  borderRadius: 7,
}));

const Value = styled.label(({ theme, valueColor }) => ({
  fontSize: 14,
  color: valueColor ? valueColor : theme.color.text,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
}));

const IndexValue = styled.label(({ theme }) => ({
  fontSize: 16,
  fontWeight: 900,
  color: theme.color.lightText,
}));

const TableRow = ({
  keys,
  row,
  index,
  hasDelete,
  handelRowDeleteClick = () => {},
  handelRowUpdateClick = () => {},
  handelRowClick = () => {},
  handelRowCancel = () => {},
  withIndex,
  translation,
  backgroungColor,
  valueColor,
  editable,
  onClick,
}) => {
  const { t } = useTranslation(translation);
  const [isHover, setIsHover] = useState(null);
  const [selectedRow, setSelectedRow] = useState(row);

  useEffect(() => {
    setSelectedRow(row);
  }, [row]);

  const handleInputChange = (changedRow, key, e) => {
    setSelectedRow({ ...changedRow, [key.key]: e.target.value });
  };

  const handleSelectChange = (changedRow, key, value) => {
    setSelectedRow({ ...changedRow, [key.key]: value?.value });
  };

  const handleCancelClick = (e, selectedRow) => {
    e.stopPropagation();
    handelRowCancel(selectedRow);
    setSelectedRow({ ...row, isEditMode: false, isAddMode: false });
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    setSelectedRow({ ...row, isEditMode: true });
  };

  const renderCell = (key) => {
    const isEditable = selectedRow.isEditMode || selectedRow.isAddMode;

    if (key.key === "CODE" || key.key === "STATDES") {
      return (
        <Status
          row={selectedRow}
          status={selectedRow[key.key]}
          color={selectedRow.VCOLORNAME}
        />
      );
    }

    if (key.link) {
      return (
        <div
          style={{
            cursor: "pointer",
            color: "#007AEA",
            textDecoration: selectedRow[key.key] ? "underline" : "none",
          }}
          onClick={(e) => {
            e.stopPropagation();
            openInNewTab(
              selectedRow["EXTFILENAME"],
              selectedRow[key.key],
              selectedRow["SUFFIX"]
            );
          }}
        >
          {selectedRow[key.key] || "-"}
        </div>
      );
    }

    if (key.input && isEditable) {
      return (
        <Input
          style={{ textAlign: "right" }}
          value={selectedRow[key.key]}
          onChange={(e) => handleInputChange(selectedRow, key, e)}
        />
      );
    }

    if (key.select && isEditable) {
      return (
        <Select
          height={29}
          width={200}
          value={
            selectedRow[key.key]
              ? { value: selectedRow[key.key], label: selectedRow[key.key] }
              : null
          }
          placeholder={t("common:choose")}
          options={key.selectData || []}
          onChange={(value) => handleSelectChange(selectedRow, key, value)}
        />
      );
    }

    return (
      <Value title={selectedRow[key.key]} valueColor={valueColor}>
        {renderKeyValue(key, selectedRow)}
      </Value>
    );
  };

  return (
    <StyledBox
      onClick={() => handelRowClick(selectedRow)}
      onMouseEnter={() => setIsHover(index)}
      onMouseLeave={() => setIsHover(null)}
      backgroungColor={backgroungColor}
    >
      {keys.map((key, i) => {
        if (withIndex && i === 0) {
          return (
            <BoxContent key={`index-${i}`} width={key.width || "3%"}>
              <IndexValue>
                {(index + 1).toLocaleString("en-US", {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                })}
              </IndexValue>
            </BoxContent>
          );
        }

        if (key.key === "ACTIONS") {
          return;
        }

        return (
          <BoxContent
            style={{
              display: "flex",
              margin: key.key === "CODE" || (key.key === "STATDES" && 0),
              padding: key.key === "CODE" || (key.key === "STATDES" && 0),
            }}
            key={`${key.key}-${i}`}
            width={key.width}
          >
            {renderCell(key)}
          </BoxContent>
        );
      })}

      {selectedRow.isEditMode || selectedRow.isAddMode ? (
        <BoxContent>
          <button
            onClick={(e) => handelRowUpdateClick(e, selectedRow)}
            style={{
              border: 0,
              backgroundColor: "white",
              cursor: "pointer",
              verticalAlign: "middle",
            }}
          >
            <img alt="Update" src={UpdateImg} />
          </button>
          <button
            onClick={(e) => handleCancelClick(e, selectedRow)}
            style={{
              border: 0,
              backgroundColor: "white",
              cursor: "pointer",
              verticalAlign: "middle",
            }}
          >
            <img alt="Cancel" src={CancelImg} />
          </button>
        </BoxContent>
      ) : (
        (editable || hasDelete) && (
          <BoxContent>
            {editable && (
              <button
                onClick={onClick || handleEditClick}
                style={{
                  border: 0,
                  backgroundColor: "white",
                  cursor: "pointer",
                  verticalAlign: "middle",
                }}
              >
                <img
                  alt="Edit"
                  src={EditImg}
                  style={{
                    display: isHover === index ? "block" : "none",
                  }}
                />
              </button>
            )}

            {hasDelete && (
              <button
                onClick={(e) => {
                  e.preventDefault();
                  handelRowDeleteClick(e, selectedRow);
                }}
                style={{
                  border: 0,
                  backgroundColor: "white",
                  cursor: "pointer",
                  verticalAlign: "middle",
                }}
              >
                <img
                  alt="Delete"
                  src={DeleteImg}
                  style={{
                    display: isHover === index ? "block" : "none",
                  }}
                />
              </button>
            )}
          </BoxContent>
        )
      )}
    </StyledBox>
  );
};

export default inject()(observer(TableRow));
